import z from 'zod';
import { Cache } from '../../cache';

export type DiscordActivityPluginOptions = {
  discordBotToken: string;
  guildMembershipCache: Cache;
};

export type OAuthScopes =
  | 'bot'
  | 'rpc'
  | 'identify'
  | 'connections'
  | 'email'
  | 'guilds'
  | 'guilds.join'
  | 'guilds.members.read'
  | 'gdm.join'
  | 'messages.read'
  | 'rpc.notifications.read'
  | 'rpc.voice.write'
  | 'rpc.voice.read'
  | 'rpc.activities.write'
  | 'webhook.incoming'
  | 'applications.commands'
  | 'applications.builds.upload'
  | 'applications.builds.read'
  | 'applications.store.update'
  | 'applications.entitlements'
  | 'relationships.read'
  | 'activities.read'
  | 'activities.write'
  | 'dm_channels.read';

export const DiscordActivitySignInBodySchema = z.object({
  code: z.string(),
  guildId: z.string().nullable(),
  channelId: z.string().nullable(),
  instanceId: z.string(),
});

export type DiscordActivitySignInBody = z.infer<typeof DiscordActivitySignInBodySchema>;
